import { colors } from "../../../styles/colors";
import fontWeight from "../../../styles/mui/fontWeight";

export const FaqsHeader = () => ({
  backgroundColor: colors.fonts[18],
  padding: "1.5rem 1.5rem 1rem 1.5rem",
  height: "9.2rem",
});

export const ContactInfoTableCell = () => ({
  border: `1px solid ${colors.portalColor[10]}`,
});

export const HeaderTableCell = () => ({
  border: `1px solid ${colors.portalColor[10]}`,
  backgroundColor: "rgba(0, 0, 0, .15)",
});

export const EmailLink = () => ({
  textDecoration: "none",
  color: colors.arrowIcon[1],
  fontSize: "1rem",
  fontWeight: fontWeight[2],
  "&:hover": {
    textDecoration: "underline",
  },
});

export const QuestionButton = () => ({
  color: colors.fonts[18],
  padding: "0.5rem 0.75rem",
  textTransform: "none",
  fontSize: "1.12rem",
  fontWeight: fontWeight[2],
  WebkitJustifyContent: "flex-start",
  justifyContent: "flex-start",
  margin: 0,
  "&:hover": {
    textDecoration: "underline",
    border: `3px solid ${colors.portalColor[15]}`,
    backgroundColor: colors.portalColor[9],
    borderRadius: "0.5rem",
    color: colors.portalColor[22],
  },
  "&:active": {
    backgroundColor: colors.portalColor[9],
    border: `3px solid ${colors.portalColor[15]}`,
  },
});
export const AuthContainer = {
  display: "flex",
  flexDirection: "column",
  maxWidth: "100%",
  minWidth: "90%",
  minHeight: "75vh",
  maxHeight: "75vh",
  overflowY: "auto",
};

export const AccordionDetailsStyle = () => ({
  border: `1px solid ${colors.portalColor[20]}`,
  minHeight: "3.7rem",
  display: "flex",
  alignItems: "center",
  padding: "1.2rem 1.4rem",
});

export const AccordionSummaryStyle = () => ({
  backgroundColor: colors.portalColor[23],
  height: "4rem",
  border: `1px solid ${colors.portalColor[20]}`,
  "& .MuiAccordionSummary-content": {
    margin: 0,
    alignItems: "center",
  },
  "& .MuiAccordionSummary-content.Mui-expanded": {
    margin: 0,
  },
  "& .Mui-expanded": {
    minHeight: "4rem",
  },
});

export const AccordionStyle = () => ({
  marginBottom: "1rem",
});

export const ContactGrid = () => ({
  padding: "0.4rem 1rem 0",
});

export const InformationGrid = () => ({
  padding: "1rem 1rem 0",
});

export const GridContainer = () => ({
  backgroundColor: colors.white[1],
  paddingBottom: "0.7rem",
});

export const AnchorTagStyle = (isLinkUnderline: boolean) => ({
  "& a": {
    color: colors.arrowIcon[1],
    textDecoration: isLinkUnderline ? "underline" : "none",
    "&:hover": {
      color: colors.portalColor[22],
      textDecoration: "underline",
    },
  },
});

export const SpanStyle = {
  color: colors.portalColor[4],
};
